import { isValidElement as d, cloneElement as p, createContext as v, useContext as T } from "react";
import { jsx as f, Fragment as g } from "react/jsx-runtime";
const C = (e) => (t, s) => d(t) || typeof t == "string" ? t : e(s);
function y(e) {
  return Object.prototype.toString.call(e) === "[object Object]" && Object.keys(e).every(
    (t) => typeof t == "string" && typeof e[t] == "string"
  );
}
const u = (e) => typeof e == "object" && e !== null && d(e);
function E(e) {
  if (!y(e))
    throw new Error(
      `TranslationsContext value is invalid: ${JSON.stringify(e)}`
    );
  return (s, x = {}) => {
    const c = (e == null ? void 0 : e[s]) ?? s, n = [], h = /{([^}]+)}/g;
    let l = 0, r;
    for (; (r = h.exec(c)) !== null; ) {
      const o = c.slice(l, r.index);
      n.push(o);
      const i = r[1];
      if (!i)
        continue;
      const a = x[i];
      n.push(a === void 0 ? r[0] : a), l = r.index + r[0].length;
    }
    return n.push(c.slice(l)), n.some(u) ? /* @__PURE__ */ f(g, { children: n.map(
      (o, i) => u(o) ? p(o, { key: i }) : o
    ) }) : n.join("");
  };
}
const m = v(
  void 0
), b = (e) => /* @__PURE__ */ f(m.Provider, { value: e.value, children: e.children });
b.displayName = "TranslationsProvider";
const O = () => {
  const e = T(m);
  if (!e)
    throw new Error(
      "useTranslate must be used inside a <TranslationsProvider />"
    );
  return e;
};
export {
  b as TranslationsProvider,
  C as createFallbackTranslator,
  E as createTranslateFunction,
  O as useTranslate
};
